import { api } from "../configs/apiConfig";

const SettingsService = {
  
   //etch all settings from the backend

  getAllSettings: async () => {
    try {
      const response = await api.get("/setting");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

 
  //Fetch a specific setting by key

  getSetting: async (key) => {
    try {
      const response = await api.get(`/setting/${key}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

 
   // Update a specific setting
   
  updateSetting: async (key, value) => {
    try {
      const response = await api.put(`/setting/${key}`, value);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get organizational settings in an easy-to-use format
  getSettings: async () => {
    try {
      const response = await SettingsService.getSetting('organization');
      if (response && response.value) {
        try {
          const settings = JSON.parse(response.value);
          return {
            organizationName: settings.OrganizationName || settings.organizationName || '',
            organizationLogo: settings.OrganizationLogo || settings.organizationLogo || '',
            organizationDescription: settings.OrganizationDescription || settings.organizationDescription || '',
            organizationAddress: settings.OrganizationAddress || settings.organizationAddress || '',
            organizationPhone: settings.OrganizationPhone || settings.organizationPhone || '',
            organizationEmail: settings.OrganizationEmail || settings.organizationEmail || ''
          };
        } catch (e) {
          console.error("Error parsing settings:", e);
          return {};
        }
      }
      return {};
    } catch (error) {
      console.error("Error fetching settings:", error);
      return {};
    }
  },

  // Get user dashboard settings with defaults
  getUserDashboardSettings: async () => {
    try {
      const response = await SettingsService.getSetting('userDashboard');
      if (response && response.value) {
        try {
          return JSON.parse(response.value);
        } catch (e) {
          console.error("Error parsing user dashboard settings:", e);
          return {
            darkMode: false,
            formOpacity: 0.85,
            formBlur: 1.0,
            backgroundImage: null,
            baseColor: null,
            backgroundImageBlur: 0
          };
        }
      }
      return {
        darkMode: false,
        formOpacity: 0.85,
        formBlur: 1.0,
        backgroundImage: null,
        baseColor: null,
        backgroundImageBlur: 0
      };
    } catch (error) {
      console.error("Error fetching user dashboard settings:", error);
      return {
        darkMode: false,
        formOpacity: 0.85,
        formBlur: 1.0,
        backgroundImage: null,
        baseColor: null,
        backgroundImageBlur: 0
      };
    }
  }
};

export default SettingsService;
